module.exports = __webpack_public_path__ + "static/media/spikes.31648be8.svg";